<template>
  <div class="filter-custom">
    <div class="filter-left">
      <div class="sort-info" @click="handleFilter('sort')">
        <span>{{ filterData[pageType].sortLabel || $t('shared.filter.sort') }}</span>
        <img class="icon-img" src="@/assets/images/icon_mnew_down.png" alt="">
      </div>
    </div>
    <div v-if="isFunnel">
      <img v-if="bascInfoChecked || storeBelongChecked || storeVisitChecked" class="filter-img" src="@/assets/images/guolvCheck.png" alt="" @click="openFilter">
      <img v-else class="filter-img" src="@/assets/images/guolv.png" alt="" @click="openFilter">
    </div>
    <van-popup v-model="filterShow" class="right-filter-info" position="right" :style="{ height: '100vh', width: '85%' }">
      <div class="title">{{ $t('shared.filter.filter') }}</div>
      <div class="collapse-content-info" v-if="isFunnel">
        <van-collapse v-model="activeNames" accordion>
          <van-collapse-item :title="$t('shared.title.basicInfo')" name="1">
            <template #title>
              <div class="collapse-title">{{ $t('shared.title.basicInfo') }} <span :class="{'collapse-checked': bascInfoChecked}"></span></div>
            </template>
            <div class="form-field">
              <div class="field-label">{{ $t('shared.title.storeTag') }}</div>
              <div class="field-value">
                <div class="radio-name" :class="{'value-check': filterData[pageType].customerTag === subItem.value}" v-for="(subItem, subIndex) in storeTagTypeList" :key="subIndex" @click="handleCheck(subItem, 'customerTag')">{{ subItem.label }}</div>
              </div>
            </div>
            <div class="form-field">
              <div class="field-label">{{ $t('shared.title.productListed') }}</div>
              <div class="field-value">
                <div class="radio-name" :class="{'value-check': isProject === ''}" @click="handleCheck('', 'isProject')">{{ $t('shared.filter.noFilter') }}</div>
                <div class="radio-name" :class="{'value-check': isProject === 'Filter'}" @click="handleCheck('Filter', 'isProject')">{{ $t('shared.titleOne') }}</div>
              </div>
              <div class="select-info" v-show="isProject === 'Filter'">
                <van-dropdown-menu active-color="#307bff">
                  <van-dropdown-item v-model="filterData[pageType].shelfOperate" :options="specialProjectOperateList" />
                </van-dropdown-menu>
                <van-checkbox-group class="checkbox-custom" v-model="filterData[pageType].shelfProductIdList">
                  <van-checkbox shape="square" v-for="(subItem, subIndex) in globalData.productList" :key="subIndex" :name="subItem.id">{{ subItem.productName }}</van-checkbox>
                </van-checkbox-group>
              </div>
            </div>
            <div class="form-field" v-if="pageType !== 'incentive'">
              <div class="field-label">{{ $t('shared.title.incentive') }}</div>
              <div class="field-value">
                <div class="radio-name" :class="{'value-check': filterData[pageType].incentiveType === subItem.value}" v-for="(subItem, subIndex) in incentiveTypeList" :key="subIndex" @click="handleCheck(subItem, 'incentiveType')">{{ subItem.label }}</div>
              </div>
            </div>
            <div class="form-field">
              <!-- 是否举办过Pop up Event -->
              <div class="field-label">{{ $t('shared.title.eventHeld') }}</div>
              <div class="field-value">
                <div class="radio-name" :class="{'value-check': filterData[pageType].isPopUpEvent === subItem.value}" v-for="(subItem, subIndex) in isPopUpEventList" :key="subIndex" @click="handleCheck(subItem, 'isPopUpEvent')">{{ subItem.label }}</div>
              </div>
            </div>
          </van-collapse-item>
          <van-collapse-item :title="$t('shared.title.storeAssignment')" name="2">
            <template #title>
              <div class="collapse-title">{{ $t('shared.title.storeAssignment') }} <span :class="{'collapse-checked': storeBelongChecked}"></span></div>
            </template>
            <div class="form-field">
              <div class="field-value">
                <div class="radio-name" :class="{'value-check': storeBelongToVal === ''}" @click="handleCheck('', 'storeBelongToVal')">{{ $t('shared.filter.noFilter') }}</div>
                <div class="radio-name" :class="{'value-check': storeBelongToVal === 'Department'}" @click="handleCheck('Department', 'storeBelongToVal')">{{ $t('shared.title.filterDepartment') }}</div>
              </div>
              <div class="select-info" v-if="storeBelongToVal === 'Department'">
                <!-- v-model="filterData[pageType].deptIdList" -->
                <XuCascader v-model="filterData[pageType].deptIdList" :deptOption="deptOption" />
              </div>
              <div class="field-value">
                <div class="radio-name" :class="{'value-check': storeBelongToVal === 'Person'}" @click="handleCheck('Person', 'storeBelongToVal')">{{ $t('shared.title.filterPerson') }}</div>
              </div>
              <van-checkbox-group v-show="storeBelongToVal === 'Person'" v-model="filterData[pageType].personVal" @change="handleCheck('Person', 'personVal')">
                <van-checkbox shape="square" v-for="(subItem, subIndex) in storePerSonList" :key="subIndex" :name="subItem.value">{{ subItem.label }}</van-checkbox>
              </van-checkbox-group>
              <XuSelect v-if="filterData[pageType].personVal.includes('customize')" v-model="filterData[pageType].userIdList" :dataOptions="globalData.userOptions" :multiple="true" :fieldNames="{label: 'nickName', value: 'id'}" />
            </div>
          </van-collapse-item>
          <van-collapse-item :title="$t('shared.title.storeVisit')" name="3" v-if="pageType === 'storeMaintain'">
            <template #title>
              <div class="collapse-title">{{ $t('shared.title.storeVisit') }} <span :class="{'collapse-checked': storeVisitChecked}"></span></div>
            </template>
            <div class="form-field">
              <div class="field-label">{{ $t('shared.title.visitOrNot') }}</div>
              <div class="field-value">
                <div class="radio-name" :class="{'value-check': filterData[pageType].isVisit === subItem.value}" v-for="(subItem, subIndex) in isPopUpEventList" :key="subIndex" @click="handleCheck(subItem, 'isVisit')">{{ subItem.label }}</div>
              </div>
            </div>
            <div class="form-field" v-if="filterData[pageType].isVisit !== '0'">
              <div class="field-label">{{ $t('shared.title.timeSinceLastVisit') }}</div>
              <div class="field-value">
                <div class="radio-name" :class="{'value-check': filterData[pageType].visitDay === subItem.value}" v-for="(subItem, subIndex) in timeSinceLastList" :key="subIndex" @click="handleCheck(subItem, 'visitDay')">{{ subItem.label }}</div>
              </div>
              <van-row v-if="filterData[pageType].visitDay === 'customizable'" class="row-content">
                <van-col span="11">
                  <van-field type="digit" class="field-input" v-model="filterData[pageType].visitStartDay" label="" :placeholder="$t('shared.title.minDays')" @input="(val) => handleInput(val, 'visitStartDay')" />
                </van-col>
                <van-col span="2" style="text-align: center">-</van-col>
                <van-col span="11">
                  <van-field type="digit" class="field-input" v-model="filterData[pageType].visitEndDay" label="" :placeholder="$t('shared.title.maxDays')" @input="(val) => handleInput(val, 'visitEndDay')" />
                </van-col>
                <!-- <van-col span="4" style="padding-left: 3px;">{{ $t('shared.title.days') }}</van-col> -->
              </van-row>
              <div v-if="filterData[pageType].visitDay === 'customizable'" class="days-tip">{{ $t('shared.titleThirtyFour') }}</div>
            </div>
            <div class="form-field">
              <div class="field-label">{{ $t('shared.title.reOrderOrNot') }}</div>
              <div class="field-value">
                <div class="radio-name" :class="{'value-check': isVisitProject === ''}" @click="handleCheck('', 'isVisitProject')">{{ $t('shared.filter.noFilter') }}</div>
                <div class="radio-name" :class="{'value-check': isVisitProject === 'Filter'}" @click="handleCheck('Filter', 'isVisitProject')">{{ $t('shared.titleOne') }}</div>
              </div>
              <div class="select-info" v-if="isVisitProject === 'Filter'">
                <van-dropdown-menu active-color="#007bff">
                  <van-dropdown-item v-model="filterData[pageType].reorderOperate" :options="visitProjectList" />
                </van-dropdown-menu>
                <van-checkbox-group class="checkbox-custom" v-model="filterData[pageType].reorderProductIdList">
                  <van-checkbox shape="square" v-for="(subItem, subIndex) in globalData.productList" :key="subIndex" :name="subItem.id">{{ subItem.productName }}</van-checkbox>
                </van-checkbox-group>
              </div>
            </div>
            <div class="form-field">
              <div class="field-label">{{ $t('shared.title.visitByBa') }}</div>
              <div class="field-value">
                <van-checkbox-group v-model="filterData[pageType].visitByBaVal" style="margin-top: 5px;">
                  <van-checkbox shape="square" v-for="(subItem, subIndex) in personList" :key="subIndex" :name="subItem.value" @click="handleCheck('', 'visitByBaVal')">{{ subItem.label }}</van-checkbox>
                </van-checkbox-group>
                <XuSelect v-if="filterData[pageType].visitByBaVal.includes('customize')" v-model="filterData[pageType].visitUserIdList" :dataOptions="globalData.userOptions" :multiple="true" :fieldNames="{label: 'nickName', value: 'id'}" />
                <van-checkbox style="margin-top: 5px;" v-if="filterData[pageType].visitByBaVal.includes('Me') || filterData[pageType].visitByBaVal.includes('customize')" v-model="filterData[pageType].isLastVisit" shape="square">{{ $t('shared.titleTwo') }}</van-checkbox>
              </div>
            </div>
          </van-collapse-item>
        </van-collapse>
      </div>
      <div class="filter-btn">
        <div class="reset-btn" @click="handleReset">{{ $t('shared.filter.reset') }}</div>
        <div class="confirm-btn" @click="handleConfirmFilter">{{ $t('shared.filter.viewStore') }}</div>
      </div>
    </van-popup>
    <van-popup v-model="leftShow" position="bottom" :round="true">
      <div v-show="leftFilterType === 'sort'" class="sort-content">
        <div class="filter-popup-title">{{ $t('shared.filter.sort') }}</div>
        <div class="filter-popup-content">
          <div v-for="(filterItem, filterIndex) in actualSortOption" class="project-item" :class="{'choice-active': filterData[pageType].sortVal===filterItem.value}" :key="filterIndex" @click="handlePopup(filterItem, 'sortVal')">{{ filterItem.label }}</div>
        </div>
        <div class="operate-btn">
          <van-button type="primary" @click="resetSortFilter">{{ $t('shared.filter.reset') }}</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import XuCascader from './XuCascader'
import XuSelect from './XuSelect'
import { mapState } from 'vuex'
import i18n from '@/i18n'
const newFilterData = {
  store: {
    sortVal: 'distance-0',
    sortLabel: i18n.t('shared.filter.distanceNearest'),
    customerTag: '',
    shelfOperate: '',
    shelfProductIdList: [],
    deptIdList: [],
    userIdList: [],
    personVal: [],
    incentiveType: '',
    isPopUpEvent: ''
  },
  incentive: {
    sortVal: 'distance-0',
    sortLabel: i18n.t('shared.filter.distanceNearest'),
    customerTag: '',
    shelfOperate: '',
    shelfProductIdList: [],
    deptIdList: [],
    userIdList: [],
    personVal: [],
    isPopUpEvent: ''
  },
  storeExpansion: {
    sortVal: 'distance-0',
    sortLabel: i18n.t('shared.filter.distanceNearest')
  },
  storeMaintain: {
    sortVal: 'distance-0',
    sortLabel: i18n.t('shared.filter.distanceNearest'),
    customerTag: '',
    shelfOperate: '',
    shelfProductIdList: [],
    deptIdList: [],
    userIdList: [],
    personVal: [],
    incentiveType: '',
    isPopUpEvent: '',
    isVisit: '',
    visitDay: '',
    visitStartDay: '',
    visitEndDay: '',
    reorderProductIdList: [],
    reorderOperate: '1',
    visitByBaVal: [''],
    visitUserIdList: [],
    isLastVisit: false
  },
  salesDistribution: {
    sortVal: 'distance-0',
    sortLabel: i18n.t('shared.filter.distanceNearest')
  }
}
export default {
  components: {
    XuCascader,
    XuSelect
  },
  props: {
    pageType: {
      type: String,
      default: ''
    },
    sortOption: {
      type: Array,
      default: () => []
    },
    deptOption: {
      type: Array,
      default: () => []
    },
    isFunnel: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      // 项目、排序 --------
      leftShow: false,
      leftFilterType: '',
      // 项目、排序 --------
      // 其他过滤 ----------
      filterShow: false,
      activeNames: '1',
      specialProjectOperateList: [
        { text: this.$t('shared.filter.containAny'), value: '0' },
        { text: this.$t('shared.filter.notContainAny'), value: '1' },
        { text: this.$t('shared.filter.notEqualTo'), value: '2' }
      ],
      storePerSonList: [
        { label: this.$t('shared.filter.me'), value: 'Me' },
        { label: this.$t('shared.filter.customize'), value: 'customize' }
      ],
      storeTagTypeList: [
        { label: this.$t('shared.filter.noFilter'), value: '' },
        { label: this.$t('shared.filter.sVIPCore'), value: 1 },
        { label: this.$t('shared.filter.vIPCore'), value: 2 },
        { label: this.$t('shared.filter.potential'), value: 3 },
        { label: this.$t('shared.filter.toBeVerified'), value: '0' }
      ],
      incentiveTypeList: [
        { label: this.$t('shared.filter.noFilter'), value: '' },
        { label: this.$t('shared.filter.activated'), value: 1 }, // 已开通
        { label: this.$t('shared.filter.participated'), value: 2 }, // 已参加
        { label: this.$t('shared.filter.notParticipated'), value: 3 }, // 未参加
        { label: this.$t('shared.filter.notActivated'), value: 4 } // 未开通
      ],
      isPopUpEventList: [
        { label: this.$t('shared.filter.noFilter'), value: '' },
        { label: this.$t('shared.filter.yes'), value: '1' },
        { label: this.$t('shared.filter.no'), value: '0' }
      ],
      // 其他过滤 ----------
      isProject: '',
      storeBelongToVal: '',
      isVisitProject: '',
      filterData: {
        store: {
          sortVal: 'distance-0',
          sortLabel: this.$t('shared.filter.distanceNearest'),
          customerTag: '',
          shelfOperate: '',
          shelfProductIdList: [],
          deptIdList: [],
          userIdList: [],
          personVal: [],
          incentiveType: '',
          isPopUpEvent: ''
        },
        incentive: {
          sortVal: 'distance-0',
          sortLabel: this.$t('shared.filter.distanceNearest'),
          customerTag: '',
          shelfOperate: '',
          shelfProductIdList: [],
          deptIdList: [],
          userIdList: [],
          personVal: [],
          isPopUpEvent: ''
        },
        storeExpansion: {
          sortVal: 'distance-0',
          sortLabel: this.$t('shared.filter.distanceNearest')
        },
        storeMaintain: {
          sortVal: 'distance-0',
          sortLabel: this.$t('shared.filter.distanceNearest'),
          customerTag: '',
          shelfOperate: '',
          shelfProductIdList: [],
          deptIdList: [],
          userIdList: [],
          personVal: [],
          incentiveType: '',
          isPopUpEvent: '',
          isVisit: '',
          visitDay: '',
          visitStartDay: '',
          visitEndDay: '',
          visitByBaVal: [''],
          reorderProductIdList: [],
          reorderOperate: '1',
          visitUserIdList: [],
          isLastVisit: false
        },
        salesDistribution: {
          sortVal: 'distance-0',
          sortLabel: this.$t('shared.filter.distanceNearest')
        }
      },
      timeSinceLastList: [
        { label: this.$t('shared.filter.noFilter'), value: '' },
        { label: this.$t('shared.filter.lessThanDays'), value: '0@6' },
        { label: this.$t('shared.filter.timeDays'), value: '7@15' },
        { label: this.$t('shared.filter.customize'), value: 'customizable' }
      ],
      personList: [
        { label: this.$t('shared.filter.noFilter'), value: '' },
        { label: this.$t('shared.filter.me'), value: 'Me' },
        { label: this.$t('shared.filter.customize'), value: 'customize' }
      ],
      visitProjectList: [
        { text: this.$t('shared.filter.containAny'), value: '1' },
        { text: this.$t('shared.filter.containAll'), value: '0' }
      ]
    }
  },
  computed: {
    ...mapState({
      globalData: 'globalData'
    }),
    actualSortOption () {
      if (this.sortOption && this.sortOption.length > 0) {
        return this.sortOption
      }
      return [
        { label: this.$t('shared.filter.distanceNearest'), value: 'distance-0' },
        { label: this.$t('shared.filter.distanceFarthest'), value: 'distance-1' },
        { label: this.$t('shared.filter.distanceLatest'), value: 'updateTime-1' },
        { label: this.$t('shared.filter.distanceEarliest'), value: 'updateTime-0' }
      ]
    },
    bascInfoChecked () {
      const {
        customerTag = '',
        shelfProductIdList = [],
        shelfOperate = '',
        incentiveType = '',
        isPopUpEvent = ''
      } = this.filterData[this.pageType]
      return (
        customerTag !== '' ||
        shelfProductIdList.length > 0 ||
        shelfOperate !== '' ||
        incentiveType !== '' ||
        isPopUpEvent !== ''
      )
    },
    storeBelongChecked () {
      const {
        deptIdList = [],
        personVal = [],
        userIdList = []
      } = this.filterData[this.pageType]
      return (
        deptIdList.length > 0 || personVal.length > 0 || userIdList.length > 0
      )
    },
    storeVisitChecked () {
      const { reorderProductIdList = [], reorderOperate = '1', isVisit = '', visitDay = '', visitStartDay = '', visitEndDay = '', visitUserIdList = [], isLastVisit = false, visitByBaVal = [''] } = this.filterData[this.pageType]
      return (
        reorderProductIdList.length > 0 ||
        reorderOperate !== '1' ||
        isVisit !== '' ||
        visitDay !== '' ||
        visitStartDay !== '' ||
        visitEndDay !== '' ||
        visitUserIdList.length > 0 ||
        isLastVisit ||
        visitByBaVal.some(item => item !== '')
      )
    }
  },
  methods: {
    // 单选
    handleCheck (params, type) {
      if (['isProject'].includes(type)) {
        this[type] = params
        this.filterData[this.pageType].shelfOperate = '0'
        this.filterData[this.pageType].shelfProductIdList = []
      } else if (['storeBelongToVal'].includes(type)) {
        this[type] = params
        this.filterData[this.pageType].personVal = []
        this.filterData[this.pageType].userIdList = []
        this.filterData[this.pageType].deptIdList = []
      } else if (['personVal'].includes(type)) {
        if (!this.filterData[this.pageType].personVal.includes('customize')) {
          this.filterData[this.pageType].userIdList = []
        }
      } else if (['isVisitProject'].includes(type)) {
        this[type] = params
        this.filterData[this.pageType].reorderOperate = '1'
        this.filterData[this.pageType].reorderProductIdList = []
      } else if (['visitDay'].includes(type)) {
        this.filterData[this.pageType][type] = params.value
        this.filterData[this.pageType].visitStartDay = ''
        this.filterData[this.pageType].visitEndDay = ''
      } else if (['visitByBaVal'].includes(type)) {
        const newVisitByBaVal = JSON.parse(JSON.stringify(this.filterData[this.pageType].visitByBaVal))
        if (newVisitByBaVal[newVisitByBaVal.length - 1] === '' || newVisitByBaVal.length === 0) {
          this.filterData[this.pageType][type] = ['']
          this.filterData[this.pageType].isLastVisit = false
          this.filterData[this.pageType].visitUserIdList = []
        } else {
          this.filterData[this.pageType][type] = this.filterData[this.pageType][type].filter(subItem => subItem !== '')
        }
        if (!newVisitByBaVal.includes('customize')) {
          this.filterData[this.pageType].visitUserIdList = []
        }
      } else {
        this.filterData[this.pageType][type] = params.value
      }
    },
    handleInput (val, type) {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        clearTimeout(this.timer)
        this.timer = null
        // 只能输入正整数
        if (['visitStartDay', 'visitEndDay'].includes(type)) {
          this.filterData[this.pageType][type] = val.replace(/[^\d]/g, '').replace(/^0+([1-9])/g, '$1')
          if (['visitEndDay'].includes(type) && this.filterData[this.pageType][type]) {
            this.filterData[this.pageType][type] = Number(this.filterData[this.pageType][type]) < Number(this.filterData[this.pageType].visitStartDay) ? '' : this.filterData[this.pageType][type]
          }
        }
      }, 500)
    },
    // 其他筛选
    openFilter () {
      this.filterShow = true
    },
    resetSortFilter () {
      this.filterData[this.pageType].sortVal = 'distance-0'
      this.filterData[this.pageType].sortLabel = this.$t('shared.filter.distanceNearest')
      this.leftShow = false
      this.handleConfirmFilter()
    },
    // 点击项目、排序筛选
    handleFilter (type) {
      this.leftFilterType = type
      this.leftShow = true
    },
    // 选择项目、排序
    handlePopup (params, type) {
      if (type === 'sortVal') {
        this.filterData[this.pageType].sortVal = params.value
        this.filterData[this.pageType].sortLabel = params.label
      }
      this.handleConfirmFilter()
      this.leftShow = false
    },
    setDefaultVal (type, params = {}) {
      if (type === 'All') {
        this.filterData[this.pageType] = JSON.parse(JSON.stringify(params))
      }
    },
    handleReset () {
      this.isProject = ''
      this.storeBelongToVal = ''
      this.isVisitProject = ''
      this.filterData = JSON.parse(JSON.stringify(newFilterData))
      this.handleConfirmFilter()
    },
    handleConfirmFilter () {
      this.$emit('changeFilter', this.filterData[this.pageType])
      this.filterShow = false
    }
  }
}
</script>

<style lang="less" scoped>
.filter-custom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 35px;
  padding: 10px;
  background-color: #fff;
  border-bottom: 1px solid #eee;
  font-size: 12px;
  overflow: hidden;
  .filter-left {
    display: flex;
    align-items: center;
    .project-info,
    .sort-info {
      display: flex;
      align-items: center;
    }
    .project-info {
      margin-right: 15px;
    }
  }
  .icon-img {
    width: 20px;
    height: 20px;
  }
  .filter-img {
    width: 16px;
    height: 16px;
  }
}
.sort-content,
.project-content {
  padding: 10px 0;
  .filter-popup-title {
    font-weight: bold;
    font-size: 16px;
    text-align: center;
    margin-bottom: 10px;
  }
  .filter-popup-content {
    height: 266px;
    margin-top: 10px;
    overflow: auto;
    .filter-item {
      width: 100%;
      margin-bottom: 5px;
      .item-title {
        width: 100%;
        color: #000;
        font-weight: bold;
        font-size: 12px;
        padding: 7px 0;
      }
      .item-content {
        width: 100%;
        display: flex;
        // justify-content: space-between;
        flex-wrap: wrap;
        .filter-name {
          width: 31%;
          height: 27px;
          color: #000;
          text-align: center;
          line-height: 27px;
          font-size: 11px;
          background-color: #f3f6fc;
          border-radius: 6px;
          margin-top: 5px;
          margin-bottom: 5px;
          // padding: 0 5px;
          margin-right: 5px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .active-status {
          background-color: #1989fa;
          color: #fff;
        }
      }
    }
    .project-item {
      display: flex;
      align-items: center;
      padding: 10px;
      height: 47px;
      font-size: 12px;
      border-bottom: 1px solid #dce5f6;
    }
    .choice-active {
      color: #307bff;
    }
  }
  .operate-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 3px;
    /deep/.van-button {
      width: 120px;
      height: 40px;
      background-color: #dce5f6;
      border: 1px solid #dce5f6;
      border-radius: 8px;
      color: #000;
    }
    .confirm-btn {
      width: 200px;
      color: #fff;
      background-color: #307bff;
      border: 1px solid #307bff;
    }
  }
}
.right-filter-info {
  overflow: hidden;
  // /deep/.van-collapse-item__content {
  // overflow-y: auto;
  // }
  .title {
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    text-align: center;
    font-weight: bold;
  }
  .collapse-title {
    display: flex;
    align-items: center;
    font-weight: bold;
  }
  .form-field {
    color: #000;
    font-size: 12px;
    margin-bottom: 5px;
    .field-label {
      margin-bottom: 5px;
      font-weight: bold;
    }
    .field-value {
      display: flex;
      flex-wrap: wrap;
      font-size: 12px;
      box-sizing: border-box;
      .radio-name {
        padding: 3px 8px;
        margin-right: 5px;
        margin-bottom: 5px;
        border-radius: 5px;
        background-color: #e8effc;
        border: 1px solid #fff;
      }
    }
    .value-check {
      color: #307bff;
      border: 1px solid #307bff !important;
    }
    .select-info {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
    /deep/.van-checkbox-group {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .van-checkbox {
        margin-right: 5px;
        margin-bottom: 5px;
        .van-checkbox__label {
          margin-left: 3px;
        }
      }
    }
    .checkbox-custom {
      padding-top: 5px;
    }
    /deep/.van-dropdown-menu__title--active,
    /deep/.van-dropdown-item__option--active {
      color: #000;
    }
    /deep/.van-dropdown-menu {
      width: 120px;
      margin-right: 10px;
      .van-dropdown-menu__item {
        margin-right: 4px;
      }
      .van-dropdown-menu__title {
        font-size: 12px;
        padding: 0;
        padding-right: 8px;
      }
      .van-dropdown-menu__bar {
        height: 30px;
        border: 1px solid #dcdfe6;
      }
      .van-dropdown-menu__title::after {
        border-color: transparent transparent #000 #000;
      }
      .van-dropdown-item {
        z-index: 999;
      }
      .van-cell {
        font-size: 12px;
      }
    }
    .row-content {
      display: flex;
      align-items: center;
      font-size: 12px;
      .field-input {
        border: 1px solid #eee;
        padding: 5px 10px;
        font-size: 12px;
      }
    }
    .days-tip {
      color: #7e7f7f;
      font-size: 10px;
      margin-top: 5px;
    }
  }
  .filter-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 58px;
    padding: 0 10px;
    border-top: 1px solid #edebeb;
    background-color: #fff;
    z-index: 99;
    .reset-btn,
    .confirm-btn {
      width: 48%;
      height: 36px;
      line-height: 36px;
      text-align: center;
      border: 1px solid #000;
      border-radius: 10px;
    }
    .reset-btn {
      background: #fff;
    }
    .confirm-btn {
      border: none;
      color: #fff;
      background-color: #307bff;
    }
  }
  .collapse-checked {
    width: 10px;
    height: 10px;
    background-color: #307bff;
    border-radius: 50%;
    margin-left: 5px;
  }
  .collapse-content-info {
    /deep/.van-collapse {
      height: calc(100vh - 180px);
      overflow: auto;
      overflow-y: auto;
      // .van-collapse-item {
      //  pointer-events: none;
      // }
    }
  }
}
/deep/.van-hairline--top-bottom::after {
  display: none;
}
</style>
